import { EmpresaResumo } from "./EmpresaResumo";
import { GrupoResumo } from "./GrupoResumo";
import { PessoaResumo } from "./PessoaResumo";
import { UsuarioResumo } from "./UsuarioResumo";

export class AvisoDetalhado {
  id!: number;
  titulo!: string;
  mensagem!: string;
  dataAgendamento!: string;
  status!: string;

  usuarios!: UsuarioResumo[];
  pessoas!: PessoaResumo[];
  grupos!: GrupoResumo[];
  empresas!: EmpresaResumo[];

}
